import { useCallback } from "react";
import styles from "./IconButton.module.scss";
import cn from "classnames";
import { Loader } from "@components/new/Loader";
import { IconButtonSize, IconButtonType } from "./types.ts";

interface IconButtonProps {
  className?: string;
  onClick?: (e: any) => void;
  type?: IconButtonType;
  size?: IconButtonSize;
  loading?: boolean | undefined;
  disabled?: boolean | undefined;
  icon?: string | React.FunctionComponent<React.SVGAttributes<SVGElement>>;
}

export const IconButton = ({
  type: btnType_,
  size,
  disabled,
  className,
  icon,
  loading,
  onClick,
}: IconButtonProps) => {
  const btnType = btnType_ || IconButtonType.PRIMARY;
  const btnSize = size || IconButtonSize.L;

  const handleOnClick = useCallback((e: any) => {
    e && e.stopPropagation();
    if (!disabled && !loading && onClick) onClick(e);
  }, [onClick, disabled, loading])

  return (
    <button
      onClick={handleOnClick}
      className={cn(
        styles.button,
        className,
        styles[btnType],
        styles[`size-${btnSize}`],
        loading && styles.buttonLoading,
      )}
      disabled={disabled}
      type="button"
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          {typeof icon === "string" && (
            <img alt="icon" src={icon} />
          )}
          {typeof icon === "function" && icon({})}
        </>
      )}
    </button>
  );
};
